import React, { createContext, useContext, useState, useEffect } from 'react';

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  // Default to 'Adidas' as requested
  const [company, setCompany] = useState(() => {
    const storedCompany = localStorage.getItem('userCompany');
    return storedCompany || 'Adidas';
  });

  // This will be set to true when the user is a customer (not an admin)
  const [isCustomerView, setIsCustomerView] = useState(() => {
    const storedViewType = localStorage.getItem('isCustomerView');
    return storedViewType === 'true';
  });

  useEffect(() => {
    localStorage.setItem('userCompany', company);
  }, [company]);

  useEffect(() => {
    localStorage.setItem('isCustomerView', isCustomerView.toString());
  }, [isCustomerView]);

  const value = {
    company,
    setCompany,
    isCustomerView,
    setIsCustomerView
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};